import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { algoliaSearch, ALGOLIA_HITS_PER_PAGE } from '~/lib/algolia'

import { SortByValues } from '~/providers/FilterProvider'

import getAlgoliaProductIndex from '~/utils/get-algolia-product-index'

export type DataFiltersParams = {
  sortBy?: typeof SortByValues
  defaultFilters?: any
  q: string
  locale: string
  page?: number
  enabled?: boolean
  key: string
  queryOptions?: UseInfiniteQueryOptions
  hitsPerPage?: number
}

function useAlgoliaSearchQuery({
  sortBy,
  q,
  locale,
  enabled,
  key,
  queryOptions,
  hitsPerPage,
}: DataFiltersParams) {
  const indexName = getAlgoliaProductIndex()
  const index = algoliaSearch.client.initIndex(`${locale}_${indexName}`)

  return useInfiniteQuery(
    [key, {}, q, locale, sortBy],
    async ({ pageParam = 0 }) => {
      const res = await index.search(q, {
        page: pageParam,
        typoTolerance: false,
        analyticsTags: ['search'],
        attributesToHighlight: [
          'name',
          'designer',
          'metal',
          'stone',
          'categories',
        ],
        restrictHighlightAndSnippetArrays: true,
        hitsPerPage: hitsPerPage ?? ALGOLIA_HITS_PER_PAGE,
      })

      const nextPage = res?.nbPages > res?.page + 1 ? res?.page + 1 : null

      return {
        data: res?.hits ?? null,
        page: nextPage,
        nbHits: res?.nbHits ?? null,
      }
    },
    {
      onSuccess: (data) => {
        queryOptions?.onSuccess?.(data)
      },
      keepPreviousData: true,
      getNextPageParam: (lastPage) => lastPage?.page,
      refetchOnWindowFocus: false,
      enabled,
    },
  )
}

export default useAlgoliaSearchQuery
